import { getI18nString, withSalesChannelArchivedSuffix } from 'utils/I18nUtils';
import { ChannelGroupSetting } from './ChannelGroupSettings';

/**
 * 活動群組（L1 object）與報表的渠道顯示名稱，停用渠道**帶一次**「(停用)」後綴。
 *
 * 名稱來源依序是：逐渠道的 i18n 覆寫 `l1Object.labels.channel_<channel>` →
 * registry 裡的渠道名 → 呼叫端給的原字串（registry 還沒載入、或渠道已從後端消失）。
 *
 * ⚠️ 這裡刻意**不走** `getSalesChannelName`：`salesChannels.<id>` 那份 resource 在建立時
 * 就把後綴烘進字串了（見 `RestfulChannelGroupWebService.wrapChannelGroup`），拿它當名稱
 * 再補一次後綴就會變成「EdiMax (停用) (停用)」。後綴一律在這裡、對所有來源加同一次。
 *
 * ⚠️ 後綴判定 fail-open：`channelGroupId` 解析不出數字就不加後綴。寧可少一個後綴，也不要
 * 把後綴貼到錯的渠道上 —— 特別是空字串，`Number('')` 是 0，剛好是 RTB 的 channelGroupId
 * （`ChannelGroupSetting.isEffectivelyArchivedChannel` 已經擋掉這一種）。
 *
 * 收斂成一支是因為這段原本散在四個檔八處，而且退路各寫各的：有的退回 registry key、
 * 有的退回報表回傳的 dimension 名稱、有的退回 `config.name`，同一個渠道在不同畫面會
 * 顯示成不同字串，後綴也只有報表那三處有。
 */
export function getL1ObjectChannelName(
  channel: string,
  channelGroupId?: number | string
): string {
  // ⚠️ 空字串與 null 要先擋掉再轉數字：`Number('')` 是 0，而 0 是 RTB 的
  // channelGroupId —— 不擋的話「沒給 id」會查到 RTB，把 RTB 的名字貼到別的渠道上。
  const id =
    channelGroupId === '' || channelGroupId == null
      ? NaN
      : Number(channelGroupId);
  const registeredName = Number.isFinite(id)
    ? ChannelGroupSetting.findById(id)?.config.name
    : undefined;
  const name = getI18nString(
    `l1Object.labels.channel_${channel.toLowerCase()}`,
    registeredName ?? channel
  );
  return ChannelGroupSetting.isEffectivelyArchivedChannel(channelGroupId)
    ? withSalesChannelArchivedSuffix(name)
    : name;
}
